declare global {
  interface Window {
    __ADS_CONVERSION__?: string;
    __ROUTE__?: string;
  }
}

export function trackLead(label: string): void {
  if (typeof window === "undefined") return;
  window.gtag?.("event", "generate_lead", {
    event_category: "engagement",
    event_label: label,
  });
}

export function trackPageView(path: string, title: string): void {
  if (typeof window === "undefined") return;
  window.gtag?.("event", "page_view", { page_path: path, page_title: title });
}

const CONVERSION_FLAG = "tl_converted";

function alreadyConverted(): boolean {
  try {
    if (window.sessionStorage.getItem(CONVERSION_FLAG)) return true;
    window.sessionStorage.setItem(CONVERSION_FLAG, "1");
    return false;
  } catch {
    // sessionStorage non disponibile (es. modalità privacy): non bloccare la conversione.
    return false;
  }
}

export function trackConversion(): void {
  if (typeof window === "undefined") return;
  // Conta una sola conversione per sessione (evita doppi conteggi su refresh/ritorni a /grazie).
  if (alreadyConverted()) return;
  // Evento GA4 di conversione (lead WhatsApp). Marcalo come "conversione" in GA4.
  window.gtag?.("event", "whatsapp_lead", { event_category: "conversion" });
  // Conversione Google Ads — l'ID/etichetta si configura in index.html.
  const sendTo = window.__ADS_CONVERSION__;
  if (sendTo) {
    window.gtag?.("event", "conversion", { send_to: sendTo });
  }
}
